import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import DashboardStatistics from "../../containers/dashboard_container";
import Loader from "../universal/loader";
import { Popup, Button, Icon } from "semantic-ui-react";
import FilterAttributes from "../../containers/filter_container";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { acceptClerkOffer } from "../../data/dashboard_api"

class ProvisionalOfferListing extends Component {
  constructor(props) {
    super(props);
    this.state = {isFetching:false}
  }

  componentDidMount() {
    this.props.getProvisionalOfferData(
    );
  }

  acceptClerkOffer = async (inspection_id) => {
    this.setState({isFetching:true})
    const response = await acceptClerkOffer(inspection_id)
    await this.props.getProvisionalOfferData();
    this.setState({isFetching:false})

  }

  render() {
    const columns = [
      {
        Header: "Date",
        id: "inspection_date",
        accessor: (d) => d.inspection_time["inspection_date"],
        className: "date-width",
        headerClassName: "date-width",
        filterable: true,
        maxWidth: 140,
        Cell: ({ original, value }) => (
          <span>{moment(value, "YYYY-MM-DD").format("DD-MM-YYYY")}</span>
        ),
      },
      {
        Header: "Time",
        accessor: "inspection_time.inspection_start_time",
        className: "partTime-width",
        headerClassName: "partTime-width",
        filterable: true,
        maxWidth: 90,
      },
      {
        Header: "Company",
        accessor: "company_name",
        className: "left-aligned",
        maxWidth: 140,
        filterable: true,
      },
      {
        Header: "Furnishings",
        accessor: "property.furnishing_type",
        className: "format-capitalize",
        filterable: true,
        maxWidth: 100,
      },
      {
        Header: "Size",
        id: "Size",
        accessor: (d) => d.property["property_size"] + " Bed",
        headerClassName: "micro-width",
        className: "micro-width format-capitalize",
        filterable: true,
        maxWidth: 90,
      },
      {
        Header: "Job Type",
        accessor: "inspection_type",
        className: "formatcase mini-width",
        maxWidth: 100,
        filterable: true,
      },
      {
        Header: "Access",
        filterable: true,
        maxWidth: 100,
        Cell: ({ original, value }) => (
          <div>
            <Popup
              trigger={<Button compact size='mini'color="blue">INFO</Button>}
              content={
                <div style={{ paddingTop: "5px" }}>
                  <ul>
                    <li>
                      <strong>Get Keys From: </strong>
                      {original.access.get_keys}
                    </li>
                    <li>
                      <strong>Return keys to: </strong>
                      {original.access.return_keys}
                    </li>
                  </ul>
                </div>
              }
              position="top left"
              on="hover"
              wide
              header="Access Info"
              hideOnScroll
            />
          </div>
        ),
      },
      {
        Header: "Address",
        id: "property",
        accessor: (d) => d.property["address"],
        filterable: true,
      },
    ];

    this.props.userRole === "admin"
      ? columns.push(
          {
            Header: "Offers",
            accessor: "count",
            filterable: true,
            maxWidth: 75,
            Cell: ({ original, value }) => (
              <div>
                <Popup
                  trigger={<span><Button compact icon color="blue" size="mini" ><Icon name="list"></Icon> {value} </Button></span>}
                  content={
                    <div class="ui divided list">
                      {original.provisional_offers.map((provisional_offer) => (
                        <div class="item" key={provisional_offer.clerk.clerk_name}>
                          {provisional_offer.clerk.clerk_name}
                          {provisional_offer.clerk.accepted ?
                            <div class="ui green horizontal label right floated">Accepted</div>
                            :
                            <div class="ui red horizontal label right floated">Not Accepted</div>}
                        </div>
                      ))}
                     
                  </div>
                  }
                  position="top left"
                  on="hover"
                  wide
                  header="Clerks Offered To"
                  hideOnScroll
                />
              </div>
            ),
          },
          {
            Header: "Action",
            id: "edit",
            accessor: "id",
            sortable: false,
            Cell: ({ original, value }) => (
              <div>
                <Button
                  basic
                  compact
                  icon
                  positive
                  size="mini"
                  onClick={() => {
                    this.props.setFilter(
                      undefined,
                      undefined,
                      undefined,
                      value
                    );
                    this.props.history.push("/inspection");
                  }}
                >
                  <Icon name="eye" />
                  View
                </Button>
              </div>
            ),
          }
        )
      : columns.push(
        {
          Header: "Status",
          id: "edit",
          accessor: "accepted",
          sortable: false,
          Cell: ({ original, value }) => (
            <div>
              <Button compact className={original.accepted ? "green" : "red"} size="mini">
                {!original.accepted ? <Icon name="close" /> : <Icon name="check" />}
                {original.accepted ? "Accepted" : "Not Accepted"}
              </Button>
            </div>
          )
        },
        {          Header: "Action",
        id: "edit",
        accessor: "id",
        sortable: false,
        Cell: ({ original, value }) => (
          <div>
            <Button compact className={!original.accepted ? "green" : "red"} size="mini" onClick={ () => {this.acceptClerkOffer(value)}}>
              {original.accepted ? <Icon name="close" /> : <Icon name="check" />}
              {original.accepted ? "Revoke Interest" : "Show Interest"}
            </Button>
          </div>
        )}
      );

    return (
      <div style={{ width: "100%", margin: "auto" }} className="center-aligned">
        {!(this.props.isProvisionalOfferFetching || this.state.isFetching) && (
          <ReactTable
            data={Array.isArray(this.props.provisionalOfferData) ? this.props.provisionalOfferData : [] }
            columns={columns}
            defaultFilterMethod={(filter, row, column) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .toUpperCase()
                    .startsWith(filter.value.toUpperCase())
                : true;
            }}
            defaultPageSize={25}
            minRows={5}
            noDataText="No Provisional Offers Available"
          />
        )}
        {(this.props.isProvisionalOfferFetching || this.state.isFetching)  && (
          <Loader contain={true} customText="Loading Provisional Offers" />
        )}
        <div style={{ minHeight: "50px" }}></div>
      </div>
    );
  }
}

export default DashboardStatistics(
  FilterAttributes(withRouter(ProvisionalOfferListing))
);



// WEBPACK FOOTER //
// ./src/views/dashboard/provisional_offer_listing.js